(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cashier-pay-button", [], factory);
	else if(typeof exports === 'object')
		exports["cashier-pay-button"] = factory();
	else
		root["cashier-pay-button"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 